// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//Azure UAT
export const environment = {
  production: true,
  appcode: 'InTaxGTC',
  serviceBaseUrl: 'https://intaxgtc-uat.ey.net/INTaxGTC.API/api/',
  tokenPath: 'https://intaxgtc-uat.ey.net/INTaxGTC.API/api/Token',
  logoutUrl: 'https://intaxgtc-uat.ey.net/logout',
  sessionExpireUrl: 'https://intaxgtc-uat.ey.net/sessionexpired',
  pageAnalyticsUrl: 'https://inpageanalytics.ey.net/Pages/InsertPageAnalytic.aspx',
  APIEndpoint: "https://intaxgtc-uat.ey.net/INTaxGTC.API/",
  clientId: 'e92c478e-f5f5-447c-8bed-3b2ffaa5aaef',
  authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
  authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
  tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
  redirectUri: 'https://intaxgtc-uat.ey.net',
  IsHostingEnvAzure :true

};


